import area from "./area.json"
export default area
